// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"23a7dc10","977":"042c8deb"}[chunkId] + ".chunk.js";
};